// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comment-module__cardHeader--2OAqu{display:flex;justify-content:space-between;margin-bottom:10px}.comment-module__cardText--slNMZ{font-size:16px;line-height:20px;font-weight:400;word-break:break-word}.comment-module__dateText--2ByXI{color:#757575}", ""]);
// Exports
exports.locals = {
	"cardHeader": "comment-module__cardHeader--2OAqu",
	"cardText": "comment-module__cardText--slNMZ",
	"dateText": "comment-module__dateText--2ByXI"
};
module.exports = exports;
